import { z } from 'zod';

export interface UserDetailsErrorMessages {
	required: string;
	email: string;
	phone: string;
	minLength: string;
	maxLength: string;
	firstName: string;
	lastName: string;
	zipCode: string;
	profanity: string;
}

export const userDetailsErrorMessages = (isSpanish = false): UserDetailsErrorMessages => ({
	required: isSpanish ? 'Este campo es obligatorio' : 'This field is required',
	email: isSpanish
		? 'Por favor ingrese una dirección de correo electrónico válida'
		: 'Please enter a valid email address',
	phone: isSpanish ? 'Por favor ingrese un número de teléfono válido' : 'Please enter a valid phone number',
	minLength: isSpanish ? 'Este campo es muy corto' : 'This field is too short',
	maxLength: isSpanish ? 'Este campo es muy largo' : 'This field is too long',
	firstName: isSpanish ? 'Por favor ingrese un nombre válido' : 'Please enter a valid first name',
	lastName: isSpanish ? 'Por favor ingrese un apellido válido' : 'Please enter a valid last name',
	zipCode: isSpanish ? 'Se requiere un código postal válido' : 'Valid ZIP Code Required',
	profanity: isSpanish ? 'Texto inapropiado ingresado' : 'Inappropriate text entered',
});

export const firstNameSchema = (isSpanish = false) => {
	const m = userDetailsErrorMessages(isSpanish);
	return z
		.string({ invalid_type_error: m.required })
		.trim()
		.min(2, m.minLength)
		.regex(/^[a-zA-Z]+([ '-][a-zA-Z]+)*$/, m.firstName)
		.max(30, m.maxLength);
};

export const lastNameSchema = (isSpanish = false) => {
	const m = userDetailsErrorMessages(isSpanish);
	return z
		.string({ invalid_type_error: m.required })
		.trim()
		.min(2, m.minLength)
		.regex(/^[a-zA-Z]+([ '-][a-zA-Z]+)*$/, m.lastName)
		.max(30, m.maxLength);
};

export const emailSchema = (isSpanish = false) => {
	const m = userDetailsErrorMessages(isSpanish);
	return z.string().email(m.email);
};

export const phoneSchema = (isSpanish = false) => {
	const m = userDetailsErrorMessages(isSpanish);
	return z.string().regex(/^\(\d{3}\) \d{3}-\d{4}$/, m.phone);
};

export const zipCodeSchema = (isSpanish = false) => {
	const m = userDetailsErrorMessages(isSpanish);
	return z.coerce.string().regex(/^\d{5}$|^\d{5}-\d{4}$/, m.zipCode);
};
